module.exports = __webpack_public_path__ + "static/payor-cc-banner-f5f9dac22dc77092c5d2b42f0acea10e.jpg";